// removed by extract-text-webpack-plugin
module.exports = {"callListItem":"src-components-PatientPage-Calls-__patient-call-log__callListItem--y0-hD","dateDurationBox":"src-components-PatientPage-Calls-__patient-call-log__dateDurationBox--rL7nS","extensionBox":"src-components-PatientPage-Calls-__patient-call-log__extensionBox--2xnfp","iconBox":"src-components-PatientPage-Calls-__patient-call-log__iconBox--17ual"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PatientPage/Calls/patient-call-log.css
// module id = 1982
// module chunks = 0